import { createSelector } from 'reselect';
import { EnabledAccountsReducerState } from './types';

export const getEnabledAccountsReducerState = (state: EnabledAccountsReducerState) =>
  state.baus.enabledAccounts;
export const getEnabledAccountsIsLoading = (state: EnabledAccountsReducerState) =>
  getEnabledAccountsReducerState(state).isLoading;
export const getEnabledAccounts = (state: EnabledAccountsReducerState) =>
  getEnabledAccountsReducerState(state).enabledAccounts;

/**
 * selectEnabledAccounts
 * returns an array of enabled accounts with an id property, since no unique identifier
 * exists on the enabled accounts fetched from the backend API.
 */
export const selectEnabledAccounts = createSelector(getEnabledAccounts, (enabledAccounts) =>
  enabledAccounts.map((enabledAccount, i) => ({
    ...enabledAccount,
    id: i,
  })),
);
